import "@fontsource-variable/dancing-script";

export const INKS = [
  { value: "#111111", label: "Black" },
  { value: "#1c3f95", label: "Blue" },
] as const;

export type InkId = typeof INKS[number]["value"];

export const DEFAULT_INK: InkId = INKS[0].value;

// The family @fontsource-variable/dancing-script declares, served from this site like every other face on it.
export const SIGNATURE_FACE = "Dancing Script Variable";

export const SIGNATURE_FONT = `'${SIGNATURE_FACE}', cursive`;

// The pad draws on a canvas the moment a key is pressed, and a face still on its way is drawn in the fallback.
export function signatureFaceReady(): Promise<unknown> {
  return document.fonts.load(`48px '${SIGNATURE_FACE}'`);
}

// About the width a signature is written at on a form's line, in points; placing it any bigger is a drag away.
export const SIGNATURE_SIZE = { width: 150, height: 50 };

// A drawn signature goes on the page as ink, and a typed or uploaded one as a picture.
export const CREATION_TABS = [
  { value: "draw", label: "Draw" },
  { value: "type", label: "Type" },
  { value: "upload", label: "Upload" },
] as const;

export type CreationTab = typeof CREATION_TABS[number]["value"];

export const SIGNATURE_IMAGE_ACCEPT = "image/png,image/jpeg";
